(function () {
    'use strict';

    angular.module("imApp").factory("colorGrpLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 1210,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 1211,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
